<div style="margin-top: 20px;">
  <div class="container-tab" style="font-size: small;">
    <div class="container-column-tabs">
      <h3 class="title-main">{{'UserPages.UserPurchaseOrders.PaymentsPage.LoadingDataText' | translate}}</h3>
      <div class="flex-column">
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.PlaceOfReceiptText' | translate}}:</div>
          <!--
            <div class="wordwrap text-info">{{delivery?.placeReceipt ? delivery?.placeReceipt : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.placeReceipt || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.TransportTypeText' | translate}}:</div>
          <!--
            <div class="wordwrap text-info" style="font-weight: normal;">{{getTransportType(delivery?.transportType ?? 0) }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="getTransportType(delivery.transportType || 0)"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;"  *ngIf="isMaritime" >{{'LoadingDescriptions.PortLoadingText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info" *ngIf="isMaritime">{{delivery?.departurePort ? delivery?.departurePort?.name : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="isMaritime && delivery">
            <app-text-preview-tooltip
              [text]="delivery.departurePort?.name || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;" *ngIf="isMaritime">{{'LoadingDescriptions.PortDischargeText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info" *ngIf="isMaritime">{{delivery?.destinationPort ? delivery?.destinationPort?.name : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="isMaritime && delivery">
            <app-text-preview-tooltip
              [text]="delivery.destinationPort?.name || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;" *ngIf="!isMaritime">{{'LoadingDescriptions.AirportLoadingText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info" *ngIf="!isMaritime">{{delivery?.departureAirport ? delivery?.departureAirport?.name : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="!isMaritime && delivery">
            <app-text-preview-tooltip
              [text]="delivery.departureAirport?.name || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;" *ngIf="!isMaritime" >{{'LoadingDescriptions.AirportDischargeText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info" *ngIf="!isMaritime">{{delivery?.destinationAirport ? delivery?.destinationAirport?.name : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="!isMaritime && delivery">
            <app-text-preview-tooltip
              [text]="delivery.destinationAirport?.name || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.WeekText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info">{{delivery?.week ? delivery?.week : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.week?.toString() || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.PlaceOfDeliveryText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info">{{delivery?.placeDelivery ? delivery?.placeDelivery : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.placeDelivery || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.VesselNameText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info">{{delivery?.ship ? delivery?.ship : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.ship || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.VoyageText' | translate}}:</div>
          <!--
          <div class="wordwrap text-info">{{delivery?.voyageNumber ? delivery?.voyageNumber : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.voyageNumber || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.TypeOfMovement' | translate}}:</div>
          <!--
          <div class="wordwrap text-info">{{delivery?.typeMovement ? delivery?.typeMovement : DefaultBookingText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.typeMovement || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">BL N°:</div>
          <!--
          <div class="wordwrap text-info">{{delivery?.bl ? delivery?.bl : DefaultLoadingInfoText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.bl || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">MBL N°:</div>
          <!--
          <div class="wordwrap text-info">{{delivery?.mbl ? delivery?.mbl : DefaultLoadingInfoText }}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.mbl || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="container-column-tabs border-lats">
      <h3 class="text-transparent" >.</h3>
      <div class="flex-column">
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">Booking N°:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.booking || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.ContainerText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.containerNumber || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.LoadingDataInstructionsText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.deliveryInstructions || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.FreightPayableAtText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.freightPayableAt || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.ShippedOnBoardText' | translate}}:</div>
          <div class="wordwrap text-info">{{delivery?.shippedOnBoard ? (delivery?.shippedOnBoard | date: 'dd-MM-yyyy') : DefaultLoadingInfoText }}</div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.PlaceOfIssueText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.placeIssue || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.DateOfIssueText' | translate}}:</div>
          <div class="wordwrap text-info">{{delivery?.dateIssue ? (delivery?.dateIssue | date: 'dd-MM-yyyy') : DefaultLoadingInfoText }}</div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">ETA:</div>
          <div class="wordwrap text-info">{{delivery?.eta ? (delivery?.eta | date: 'dd-MM-yyyy') : DefaultLoadingInfoText }}</div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">ETD:</div>
          <div class="wordwrap text-info">{{delivery?.etd ? (delivery?.etd | date: 'dd-MM-yyyy') : DefaultLoadingInfoText }}</div>
        </div>
        <div class="row-data">
          <div class="text-label" style="font-weight: normal;">{{'LoadingDescriptions.TemperatureText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.containerTemperature + ' °C' || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="text-label" style="font-weight: normal;">CBM:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.containerCbm + ' %' || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="text-label" style="font-weight: normal;">{{'LoadingDescriptions.SealText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.seal || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="container-column-tabs">
      <h3 class="title-main">{{'UserPages.UserPurchaseOrders.PaymentsPage.ShippingMethodTitleText' | translate}}</h3>
      <div class="flex-column">
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.CutoffDateText' | translate}}:</div>
          <div class="wordwrap text-info">{{delivery?.cutoffDate ? (delivery?.cutoffDate | date: 'dd-MM-yyyy') : DefaultLoadingInfoText }}</div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.StackingStartText' | translate}}:</div>
          <div class="wordwrap text-info">{{delivery?.stackingStart ? (delivery?.stackingStart | date: 'dd-MM-yyyy') : DefaultLoadingInfoText }}</div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.StackingEndText' | translate}}:</div>
          <div class="wordwrap text-info">{{delivery?.stackingEnd ? (delivery?.stackingEnd | date: 'dd-MM-yyyy') : DefaultLoadingInfoText }}</div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.CarrierNameText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.truckDriverName || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.DepartureLicenseCarText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.departurePatentCar || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'LoadingDescriptions.DepartureLicenseTruckText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.departurePatentTruck || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">DUS:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.dus || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">SPS:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.sps || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">OT:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.ot || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">Ref 1:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.ref1 || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">Ref 2:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.ref2 || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">CTR:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.ctr || DefaultLoadingInfoText"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


